import React, { useState } from 'react'
import FormRegister from './authForms/FormRegister'
import { Button, Form, Modal } from 'react-bootstrap'

const ModalRegister = ({ inputsData, isShow, handleClose, handleAuth }) => {

    const [isAllowClose, setIsAllowClose] = useState(true)

    const setIsAllowClear = (val) => {
        setIsAllowClose(val)
    }

    return (
        <Modal
            show={isShow}
            onHide={() => {
                if (isAllowClose) handleClose()
            }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="modal-login"
        >
            <Modal.Header style={{ padding: '12px 30px 0 30px', alignItems: 'center' }}>
                <div className="d-flex">
                    {
                        isAllowClose &&
                        <Button
                            type='button'
                            variant="link"
                            onClick={() => {
                                handleAuth()
                            }}
                            style={{ width: 'auto', margin: 0, padding: 0 }}
                        >
                            Назад
                        </Button>
                    }
                </div>
                <button
                    className='btn p-2 ml-auto'
                    onClick={() => {
                        handleClose()
                    }}
                    style={{ position: 'relative', zIndex: 100, }}
                >
                    <span style={{ color: '#000' }}>&#x2715;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <FormRegister inputsData={inputsData} setIsAllowClear={setIsAllowClear} />
            </Modal.Body>
        </Modal>
    )
}

export default ModalRegister